import type { FaireProductEntity } from "../../entity_types/product";

export const p_tyesruxq9c: FaireProductEntity = {
  token: "p_tyesruxq9c",
  type: "product",
  name: "Love - Vintage Rainbow Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/7814de064bf04b5319058613b9554768aae66bda93cffa3c4843beaee4f75ab2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7182bbf37d69395230ca6e548e62a3ef26c8524d5a9f322b5eb3d7362b5bee2b.jpeg",
    "https://cdn.faire.com/fastly/5d1b88c43a943c4ab0249c28143863c3684ec2822a0c48778b77fed3583d4d1c.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/038ba98e5cf6c4b45f86cf5c020e7265c113bf87e096d3965f27ea861296190d.jpeg",
    "https://cdn.faire.com/fastly/dcfeb2df3e6ef9e9769488b7633b106646767dc1b0c75c09d1efcfcbe8720328.jpeg"
  ],
  priceDollars: 6.75,
  description: "Sade says Love is Stronger Than Pride. We think Love is Perfect for Pride 🥰. March, dance, lounge or snuggle in these vintage-inspired LOVE socks 🌈 .\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:28:09.576Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
